import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import { makeTransformStyles } from '../../../styles';
import MuiCardActionArea, {
  CardActionAreaProps,
} from '@material-ui/core/CardActionArea';

const CardActionArea: React.FC<CardActionAreaProps> = withStyles({
  root: (props) => {
    if (props.href) {
      return {
        borderRadius: 5,
        height: '100%',
        '&:hover .media-image': makeTransformStyles('scale(1.1)'),
        '&:hover': {
          color: 'inherit',
          textDecoration: 'none',
        },
      };
    }
    return {
      borderRadius: 5,
      height: '100%',
      cursor: 'default',
    };
  },
})(MuiCardActionArea);

export default CardActionArea;
